import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {parseUsageHeader, USAGE_HEADER, USAGE_VALUE_EVENT} from '../../shared/statistics/usage.model';
import {EventService} from '../service/event.service';

/**
 * Přečte z odpovědi hlavičku `X-Usage`, kterou BE připíná všude, kde se během requestu
 * účtovala spotřeba, a rozešle ji dál. Topbar se tím překreslí bez jediného dotazu navíc
 * a bez whitelistu AI endpointů, který by se musel udržovat.
 *
 * Broadcast místo přímé závislosti na `UsageStore` — ten visí na `HttpClient` a interceptor
 * v HTTP_INTERCEPTORS na něj nesmí, jinak NG0200 (cyklus v DI). Stejný vzor jako
 * `show-upgrade-modal` v `error.interceptor.ts`.
 */
@Injectable()
export class UsageHeaderInterceptor implements HttpInterceptor {

    constructor(private readonly eventService: EventService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(tap({
            next: event => {
                if (event instanceof HttpResponse) {
                    this.broadcastUsage(event.headers);
                }
            },
            // Non-2xx odpovědi jdou přes error kanál a `tap` s jedním callbackem je nevidí.
            // BE hlavičku připíná bez ohledu na status kód, takže právě odpověď „došel ti
            // limit" (418) nese nejčerstvější hodnotu, jakou kdy uvidíme. `tap` chybu jen
            // pozoruje, nepohlcuje ji — `error.interceptor.ts` ji dostane beze změny.
            error: (error: unknown) => {
                if (error instanceof HttpErrorResponse) {
                    this.broadcastUsage(error.headers);
                }
            },
        }));
    }

    private broadcastUsage(headers: HttpHeaders): void {
        const usage = parseUsageHeader(headers.get(USAGE_HEADER));
        if (usage) {
            this.eventService.broadcast(USAGE_VALUE_EVENT, usage);
        }
    }
}
